import getAxiosInstance from "./dataService";
import {
  FEEDBACK,
  GET_NAIRA_USER_ACCESS,
  GET_NAIRA_USER_GUIDE_URL,
  GET_RESPONSE,
  GET_SUMMARY,
  GET_SUMMARY_PUBLICATION,
  NAIRA_DISCLAIMER_URL,
  UPDATE_SYS_CTX,
  UPDATE_USER_CTX,
  GET_CONVERSATION_HISTORY,
} from "./apiUrls";

export async function getResponseService(question, asset_class, conv_id, messageIndex, deep_search) {
  if (!question || !asset_class || !conv_id || !messageIndex || deep_search === undefined) {
    throw new Error("Invalid parameters for API request");
  }
  const client = await getAxiosInstance();
  const response = await client.post(GET_RESPONSE, {
    question,
    asset_class,
    conv_id,
    messageIndex,
    deep_search
  });
  return response.data;
}

export async function feedbackService(conv_id, question_id, feedback, cmnts = "") {
  if (!conv_id || !question_id || !feedback) {
    throw new Error("Invalid parameters for API request");
  }
  const client = await getAxiosInstance();
  const response = await client.post(FEEDBACK, {
    conv_id,
    question_id,
    feedback,
    cmnts,
  });
  return response.data;
}

export async function updateSysCtxtService(user_id, context) {
  if (!user_id || !context) {
    throw new Error("Invalid parameters for API request");
  }
  const client = await getAxiosInstance();
  const response = await client.post(UPDATE_SYS_CTX, { user_id, context });
  return response.data;
}

export async function updateUserCtxtService(user_id, context) {
  if (!user_id || !context) {
    throw new Error("Invalid parameters for API request");
  }
  const client = await getAxiosInstance();
  const response = await client.post(UPDATE_USER_CTX, { user_id, context });
  return response.data;
}

export async function getSummaryService(publication) {
  if (!publication) {
    throw new Error("Invalid parameters for API request");
  }
  const client = await getAxiosInstance();
  const response = await client.post(GET_SUMMARY, { publication });
  return response.data;
}

export async function getNairaDisclaimer() {
  const client = await getAxiosInstance();
  const response = await client.get(NAIRA_DISCLAIMER_URL);
  return response.data;
}

export async function getNairaSpecialAccess() {
  const client = await getAxiosInstance();
  const response = await client.get(GET_NAIRA_USER_ACCESS);
  return response.data;
}

export async function saveNairaDisclaimer(version) {
  if (!version) {
    throw new Error("Invalid parameters for API request");
  }
  const client = await getAxiosInstance();
  const response = await client.post(NAIRA_DISCLAIMER_URL, { version });
  return response.data;
}

export async function getNairaUserGuideLink() {
  const client = await getAxiosInstance();
  const response = await client.get(GET_NAIRA_USER_GUIDE_URL);
  return response.data;
}

export async function getSummaryPublication(pubId) {
  if (!pubId) {
    throw new Error("Invalid parameters for API request");
  }
  const client = await getAxiosInstance();
  const response = await client.get(GET_SUMMARY_PUBLICATION(pubId));
  return response.data;
}

export async function getConversationHistoryService() {
  const client = await getAxiosInstance();
  const response = await client.post(GET_CONVERSATION_HISTORY, {});
  return response.data;
}